import React, { useState } from 'react';
import CustomDrawer from '../../components/shared/Drawer';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import './collectiveAgreement.css';
import CollectiveAccordion from './collectiveAccordion';
import { Loading } from '../../components/shared';
import BtButton from '../bt-button/bt-button';
import { useTranslation } from 'react-i18next';

export default function CollectiveAgreement({ agreementData, loading, error }) {
  const [t] = useTranslation('supplierDatabase', { keyPrefix: 'supplierControls' });
  const [drawerState, toggleDrawerState] = useState(false);
  let totalCount = 0;
  if (agreementData) {
    let { kollektivavtalskollen, byggInstSektorn } = agreementData;
    totalCount = kollektivavtalskollen.source_data.length +
      byggInstSektorn.collectiveAgreements.length +
      byggInstSektorn.substituteAgreements.length;
  }

  const agreementTeller = () => {
    if (error) {
      return error;
    }

    const noAgreement = !agreementData || totalCount == 0;

    // What each flag means (data sources, coverage) now lives in the (i) info icon next to the
    // "Kollektivavtal" label in supplier-controls.tsx, matching Sanktionslistor's pattern —
    // rather than a hover-only explanation hidden on the flag itself. The specific agreements
    // a supplier actually has are still available in full via "Visa avtal" below.
    return loading ? (
      [<div key="loader"><Loading loadingStyle="bubbles" type='inline' color="#ff5e15" size='30px' /></div>, <div key="empty"></div>]
    ) : (<>
      <div key="indicator">
        {totalCount > 0 ? (
          <div className="collective-agreementFlag true">
            <CheckIcon /> {t('label.yes', 'Ja')}
          </div>
        ) : (
          <div className="collective-agreementFlag false">
            <CloseIcon /> {t('label.no', 'Nej')}
          </div>
        )}
      </div>
      <div key="button">
        <BtButton
          color="white"
          size="xxs"
          disabled={noAgreement}
          class='supplierControlsElementToHide'
          onClick={() => {
            if (noAgreement) return;
            toggleDrawerState(!drawerState);
          }}
          key="button"
        >{t('collectiveAgreement.button.show', 'Visa avtal')}</BtButton>
      </div>
    </>);
  };

  return (
    <React.Fragment>
      {agreementTeller()}
      <CustomDrawer position="right" isOpen={drawerState} toggleDrawer={toggleDrawerState}>
        <div className="custom-drawer-body">
          <CollectiveAccordion data={agreementData} />
        </div>
      </CustomDrawer>
    </React.Fragment>
  );
}
